<router-outlet />

@if (isLoading()) {
  <splash-screen></splash-screen>
}

<!-- CGA-3181: optional post-login reminder to verify the phone number -->
<ng-template #phoneReminderTemplate>
  <div class="phoneReminder">
    <button type="button" class="phoneReminder__close" aria-label="Close" (click)="dismissPhoneReminder()">
      <img src="assets/images/closeIcon.svg" alt="">
    </button>

    <div class="phoneReminder__head">
      <span class="phoneReminder__icon">
        <img src="assets/images/phone-icon.svg" alt="">
      </span>
      <span class="phoneReminder__eyebrow">Phone verification</span>
    </div>

    <h5>Hey, you forgot to verify your phone number</h5>
    <p>Your number now works as a way to sign in.</p>

    <ul class="phoneReminder__perks">
      <li>Sign in with just your phone number</li>
      <li>Manage bookings connected to your phone number</li>
      <li>Instant text updates on your bookings</li>
    </ul>

    <div class="phoneReminder__actions">
      <button type="button" class="common-btn" (click)="openPhoneVerification()">Verify now</button>
      <button type="button" class="phoneReminder__later" (click)="dismissPhoneReminder()">Maybe later</button>
    </div>
  </div>
</ng-template>

<ng-template #verifyPhoneTemplate>
  <app-phone-verification-modal
    [prefillPhone]="user().phone"
    [prefillDialCode]="user().countryCode"
    [editablePhone]="!user().phone"
    [title]="user().phone ? 'Verify your mobile' : 'Add your mobile'"
    (closeModal)="closePhoneVerifyModal()"></app-phone-verification-modal>
</ng-template>
